// extracted by mini-css-extract-plugin
export default {"strip":"_34BPI"};